import { environment, getResolvedCustomerId } from './environment';
import { getCustomerById } from './customers';
import { getCustomerFromCurrentHostname } from '../lib/customerFromHostname';
import { getSelectedCustomer } from '../lib/selectedCustomer';

export function normalizeDataverseUrl(url) {
  return url.replace(/\/$/, '');
}

function extractDataverseOrgName(environmentUrl) {
  const match = environmentUrl.match(/^https:\/\/([^.]+)\.crm\d+\.dynamics\.com$/i);
  return match ? match[1] : environmentUrl;
}

/** Resolve kommune from hostname, portal selection, or deploy env — in that order. */
export function getActiveCustomerForDataverse() {
  const fromHostname = getCustomerFromCurrentHostname();
  if (fromHostname?.dataverseUrl) {
    return { customer: fromHostname, source: 'hostname' };
  }

  const selected = getSelectedCustomer();
  if (selected?.dataverseUrl) {
    return { customer: selected, source: 'selection' };
  }

  const resolvedId = getResolvedCustomerId();
  if (resolvedId) {
    const fromDeployConfig = getCustomerById(resolvedId);
    if (fromDeployConfig?.dataverseUrl) {
      return { customer: fromDeployConfig, source: 'deploy-config' };
    }
  }

  return { customer: null, source: 'default' };
}

export function getDataverseEnvironmentUrl() {
  const { customer } = getActiveCustomerForDataverse();
  if (customer?.dataverseUrl) {
    return normalizeDataverseUrl(customer.dataverseUrl);
  }
  return normalizeDataverseUrl(environment.dataverseUrl);
}

export function getDataverseApiUrl(environmentUrl = getDataverseEnvironmentUrl()) {
  const match = environmentUrl.match(/^https:\/\/([^.]+)\.crm(\d+)\.dynamics\.com$/i);
  if (match) {
    return `https://${match[1]}.api.crm${match[2]}.dynamics.com/api/data/v9.2`;
  }
  return `${environmentUrl}/api/data/v9.2`;
}

export function getDataverseScope(environmentUrl = getDataverseEnvironmentUrl()) {
  return `${environmentUrl}/.default`;
}

export function getDataverseConnectionInfo() {
  const environmentUrl = getDataverseEnvironmentUrl();
  const { customer, source } = getActiveCustomerForDataverse();
  const buildTimeUrl = normalizeDataverseUrl(environment.dataverseUrl);

  return {
    environmentUrl,
    orgName: extractDataverseOrgName(environmentUrl),
    customerId: customer?.id || null,
    customerName: customer?.name || null,
    source,
    buildTimeUrl,
    usesCustomerOverride: Boolean(customer?.dataverseUrl && environmentUrl !== buildTimeUrl)
  };
}
